import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { Layout } from 'antd';
import clone from 'clone';
import { get } from 'lodash';

import Logo from '../../components/utility/logo';
import Menu from '../../components/uielements/menu';
import Scrollbars from '../../components/utility/customScrollBar.js';

import {
  changeCurrent,
  changeOpenKeys,
  toggleCollapsed,
  toggleOpenDrawer
} from '../../actions/common';

import themes from '../../settings/themes';
import { themeConfig } from '../../settings';
import SidebarWrapper from './sidebar.style';

import options from './options';

const SubMenu = Menu.SubMenu;
const { Sider } = Layout;

const stripTrailingSlash = str => {
  if (str.substr(-1) === '/') {
    return str.substr(0, str.length - 1);
  }
  return str;
};

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.onOpenChange = this.onOpenChange.bind(this);
  }

  handleClick(e) {
    const { view, toggleCollapsed, toggleOpenDrawer } = this.props;
    this.props.changeCurrent([e.key]);
    if (view === 'MobileView') {
      setTimeout(() => {
        toggleCollapsed();
        toggleOpenDrawer();
      }, 100);
    }
  }

  onOpenChange(newOpenKeys) {
    const { openKeys, changeOpenKeys } = this.props;
    const latestOpenKey = newOpenKeys.find(
      key => !(openKeys.indexOf(key) > -1)
    );
    const latestCloseKey = openKeys.find(
      key => !(newOpenKeys.indexOf(key) > -1)
    );
    let nextOpenKeys = [];
    if (latestOpenKey) {
      nextOpenKeys = this.getAncestorKeys(latestOpenKey).concat(latestOpenKey);
    }
    if (latestCloseKey) {
      nextOpenKeys = this.getAncestorKeys(latestCloseKey);
    }
    changeOpenKeys(nextOpenKeys);
  }

  getAncestorKeys = key => {
    const map = {
      sub3: ['sub2']
    };
    return map[key] || [];
  };

  getMenuItem = ({ singleOption, submenuStyle, submenuColor }) => {
    const { key, label, leftIcon, children } = singleOption;
    const url = stripTrailingSlash(this.props.url);
    if (children) {
      return (
        <SubMenu
          key={key}
          title={
            <span className="isoMenuHolder" style={submenuColor}>
              <i className={leftIcon} />
              <span className="nav-text">
                {label}
              </span>
            </span>
          }
        >
          {children.map(child => {
            const linkTo = child.withoutDashboard
              ? `/${child.key}`
              : `${url}/${child.key}`;
            return (
              <Menu.Item style={submenuStyle} key={child.key}>
                <Link style={submenuColor} to={linkTo}>
                  {child.label}
                </Link>
              </Menu.Item>
            );
          })}
        </SubMenu>
      );
    }
    return (
      <Menu.Item key={key}>
        <Link to={`${url}/${key}`}>
          <span className="isoMenuHolder" style={submenuColor}>
            <i className={leftIcon} />
            <span className="nav-text" style={{ fontWeight: 700 }}>
              {label}
            </span>
          </span>
        </Link>
      </Menu.Item>
    );
  };

  render() {
    const {
      openDrawer,
      toggleOpenDrawer,
      height,
      openKeys,
      current,
      collapsed,
      login
    } = this.props;
    const isCollapsed = clone(collapsed) && !clone(openDrawer);
    const mode = isCollapsed ? 'vertical' : 'inline';
    const onMouseEnter = event => {
      if (openDrawer === false) {
        toggleOpenDrawer();
      }
    };

    const onMouseLeave = () => {
      if (openDrawer === true) {
        toggleOpenDrawer();
      }
    };

    const customizedTheme = themes[themeConfig.theme];

    const submenuStyle = {
      backgroundColor: 'rgba(0,0,0,0.3)',
      color: customizedTheme.textColor
    };

    const submenuColor = {
      color: customizedTheme.textColor
    };

    let optionsFilter = options;
    const screenPermission = get(login, 'result.screenPermission', []);
    const screenPermissionAllow = screenPermission.filter(screen => screen.view === true);
    const newOptions = [];
    if (screenPermission && screenPermission.length > 0) {
      optionsFilter.forEach(option => {
        screenPermissionAllow.forEach(screen => {
          if (screen.page === option.key) {
            newOptions.push(option);
          }
        });
      });
      optionsFilter = newOptions;
    }

    return (
      <SidebarWrapper>
        <Sider
          trigger={null}
          collapsible={true}
          collapsed={isCollapsed}
          width={240}
          className="isomorphicSidebar"
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          <Logo collapsed={isCollapsed} />
          <Scrollbars style={{ height: height - 70 }}>
            <Menu
              onClick={this.handleClick}
              theme="dark"
              className="isoDashboardMenu"
              mode={mode}
              openKeys={isCollapsed ? [] : openKeys}
              selectedKeys={current}
              onOpenChange={this.onOpenChange}
            >
              {options.map(singleOption =>
                this.getMenuItem({ submenuStyle, submenuColor, singleOption })
              )}
            </Menu>
          </Scrollbars>
        </Sider>
      </SidebarWrapper>
    );
  }
}

export default connect(
  state => ({
    view: state.common.view,
    current: state.common.current,
    openKeys: state.common.openKeys,
    collapsed: state.common.collapsed,
    openDrawer: state.common.openDrawer,
    height: state.common.height,
    login: state.user.login,
    userInformation: state.user.userInformation
  }),
  dispatch => bindActionCreators({
    changeCurrent,
    changeOpenKeys,
    toggleCollapsed,
    toggleOpenDrawer
  }, dispatch)
)(Sidebar);
